import { IPreflight } from '@cbgms/api/modules/root'
import { datadogRum } from '@datadog/browser-rum'
import { Environment } from '@carsys/enums/environment'

export function setupDatadog(preflight: IPreflight, isPortal: boolean) {
  if (
    preflight.DatadogAppId &&
    preflight.DatadogClient &&
    !datadogRum.getInitConfiguration() &&
    preflight.Environment !== Environment.Localhost
  ) {
    datadogRum.init({
      applicationId: preflight.DatadogAppId,
      clientToken: preflight.DatadogClient,
      site: 'datadoghq.eu' as any,
      service: 'b2b-frontend-app',
      env: preflight.Environment,
      sessionSampleRate: preflight.DatadogSessionSampleRate ? parseFloat(preflight.DatadogSessionSampleRate) : 5,
      sessionReplaySampleRate: preflight.DatadogReplaySampleRate ? parseFloat(preflight.DatadogReplaySampleRate) : 5,
      defaultPrivacyLevel: 'mask-user-input',
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      enablePrivacyForActionName: false,
      // APM trace correlation
      traceSampleRate: preflight.DatadogTraceSampleRate ? parseFloat(preflight.DatadogTraceSampleRate) : 100,
      traceContextInjection: 'all',
      allowedTracingUrls: [/^https:\/\/gms-api\.[^/]+\.carsys\.online/]
    })
    // Add isPortal to RUM global context
    datadogRum.setGlobalContextProperty('isPortal', isPortal ?? false)
  }
}

// Tags RUM events with the active shop; an empty id (logout) removes the property.
export function setDatadogShopContext(shopId?: string) {
  if (!datadogRum.getInitConfiguration()) {
    return
  }

  if (shopId) {
    datadogRum.setGlobalContextProperty('shopId', shopId)
  } else {
    datadogRum.removeGlobalContextProperty('shopId')
  }
}

export default setupDatadog
